module.exports = __webpack_public_path__ + "static/montserrat-v12-latin-900-186cae8091da578150d81958e217714a.woff";